import {
  IDrugTestList,
  IExtraSubstanceName,
  IExtraSubstanceOutcome,
  ISubstanceName,
  ISubstanceOutcome,
} from 'generated/axios';
import { t } from 'i18next';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { Box } from '@mui/system';

//drug test type labels
export const getDrugTestTypeLabel = (type: IDrugTestList | string | undefined | null): string => {
  switch (type) {
    case 'sku_542020n25':
      return 'NADAL® Tetanus';
    case 'sku_104075':
      return 'Drug-Screen Multi 7TF';
    case 'sku_104092':
      return 'Drug-Screen Multi 9TC';
    case 'sku_910082':
      return 'Drug-Screen Cup II 8C';
    case 'sku_910091':
      return 'Drug-Screen Cup II 9B';
    case 'sku_911070':
      return 'Drug-Screen Cup II 7K';
    case 'sku_1160070':
      return 'Drug-Screen Multi 7RA';
    case 'sku_1160080':
      return 'Drug-Screen Multi 7RO-AC-A';
    case 'sku_1160090':
      return 'Drug-Screen Multi 9RA';
    case 'sku_1160091':
      return 'Drug-Screen Multi 9RB';
    default:
      return type ?? '';
  }
};

//get substance label
export const getSubstanceLabel = (code: ISubstanceName | IExtraSubstanceName) => {
  switch (code) {
    case 'amp500':
      return 'AMP 500ng/ml - Amfetamina';
    case 'bup10':
      return 'BUP 10ng/ml - Buprenorfina';
    case 'bup5':
      return 'BUP 5ng/ml - Buprenorfina';
    case 'coc300':
      return 'COC 300ng/ml - Cocaina';
    case 'mdma500':
      return 'MDMA 500ng/ml - Ecstasy';
    case 'met500':
      return 'MET 500ng/ml - Metamfetamina';
    case 'mor300':
      return 'MOR/OPI 300ng/ml - Morfina/Oppiacei';
    case 'mtd300':
      return 'MTD 300ng/ml - Metadone';
    case 'tetanus':
      return 'Tetano';
    case 'thc50':
      return 'THC 50ng/ml - Marijuana';
    case 'creatinine':
      return 'Creatine';
    case 'ph':
      return 'pH';
    default:
      return code ?? '';
  }
};

//get outcome translation
export const getSubstanceOutcomeLabel = (outcome: ISubstanceOutcome | IExtraSubstanceOutcome) => {
  switch (outcome) {
    case 'unset':
      return '\u00A0';
    case 'invalid':
      return t('report.outcome.invalid');
    case 'negative':
      return t('report.outcome.negative');
    case 'positive':
      return t('report.outcome.positive');
    case 'cutoff':
      return 'Cutoff';
    case 'normal':
      return t('report.outcome.normal');
    case 'abnormal':
      return t('report.outcome.abnormal');
    default:
      return outcome ?? '';
  }
};

//render outcome icon
export const renderSubstanceOutcomeIcon = (outcome: ISubstanceOutcome | IExtraSubstanceOutcome) => {
  switch (outcome) {
    case 'negative':
    case 'normal':
      return <CheckRoundedIcon color="success" fontSize="small" />;
    case 'positive':
    case 'abnormal':
      return <ErrorRoundedIcon color="error" fontSize="small" />;
    case 'invalid':
    case 'cutoff':
      return <IndeterminateCheckBoxIcon color="disabled" fontSize="small" />;
    case 'unset':
      return <Box></Box>;
  }
};
